/* eslint-disable */

import {countries} from './_countries.js';

export const surveyJson = {
  "title": "TLF Application Form",
  "logoPosition": "right",
  "completedHtml": "<h3>Thank you!</h3>\n<p>Your application has been successfully submitted. We have sent a confirmation email to the addresses provided.</p>",
  "loadingHtml": "<h3>Loading...</h3>\n<p>Please wait...</p>",
  "pages": [
    {
      "name": "student_personal_info",
      "title": "Student's Personal Information",
      "elements": [
        {
          "type": "text",
          "name": "student_firstname",
          "title": "Student's First Name",
          "description": "Exactly as written in the international passport. Latin letters only.",
          "isRequired": true,
          "validators": [
            {
              "type": "regex",
              "text": "Please use only Latin letters (A-Z, a-z).",
              "regex": "^[A-Za-z\\-' ]+$"
            }
          ],
          "placeholder": "Sergey"
        },
        {
          "type": "text",
          "name": "student_lastname",
          "title": "Student's Last Name",
          "description": "Exactly as written in the international passport. Latin letters only.",
          "isRequired": true,
          "validators": [
            {
              "type": "regex",
              "text": "Please use only Latin letters (A-Z, a-z).",
              "regex": "^[A-Za-z\\-' ]+$"
            }
          ],
          "placeholder": "Ivanov"
        },
        {
          "type": "text",
          "name": "student_email",
          "title": "Student's Email",
          "description": "Please provide a unique personal email for the student. This will be linked to your application.",
          "isRequired": true,
          "validators": [
            {
              "type": "email"
            }
          ],
          "inputType": "email",
          "placeholder": "sergey.ivanov@leaders.tech"
        },
        {
          "type": "text",
          "name": "contact_phone",
          "title": "Contact Phone Number",
          "description": "Providing a number linked to WhatsApp or Telegram is highly recommended.",
          "isRequired": true,
          "inputType": "tel",
          "placeholder": "+1 234 567 8901",
          "validators": [
            {
              "type": "regex",
              "text": "Please enter a valid phone number including country code (e.g., +1...).",
              "regex": "^[\\+\\d\\s\\(\\)\\-]{7,20}$"
            }
          ]
        },
        {
          "type": "text",
          "name": "form_id",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "utm_source",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "utm_medium",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "utm_campaign",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "utm_term",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "utm_content",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "text",
          "name": "referrer",
          "visible": false,
          "readOnly": true
        },
        {
          "type": "html",
          "name": "telegram_auth_widget",
          "html": "<div id='telegram-auth-container'></div>"
        },
        {
          "type": "radiogroup",
          "name": "student_gender",
          "title": "Student's Gender",
          "isRequired": true,
          "choices": [
            "Male",
            "Female"
          ]
        },
        {
          "type": "text",
          "name": "student_dob",
          "title": "Date of Birth",
          "defaultValue": "2008-01-01",
          "isRequired": true,
          "inputType": "date",
          "min": "2008-09-01",
          "max": "2013-12-12"
        },
        {
          "type": "radiogroup",
          "name": "program_type",
          "title": "Which program are you applying for?",
          "description": "Please select based on the student's age and current academic level.",
          "isRequired": true,
          "validators": [
            {
              "type": "expression",
              "text": "For the 4-Year Program, the date of birth must be between Sep 1, 2011 and Dec 12, 2014.",
              "expression": "{program_type} != '4_year' or ({student_dob} >= '2011-09-01' and {student_dob} <= '2014-12-12')"
            },
            {
              "type": "expression",
              "text": "For the 3-Year Program, the date of birth must be between Sep 1, 2010 and Dec 12, 2013.",
              "expression": "{program_type} != '3_year' or ({student_dob} >= '2010-09-01' and {student_dob} <= '2013-12-12')"
            }
          ],
          "choices": [
            {
              "value": "4_year",
              "text": "4-Year Program (Starts from Grade 9 / iGCSE Year 1). Recommended age: 14-15."
            },
            {
              "value": "3_year",
              "text": "3-Year Program (Starts from Grade 10 / iGCSE Year 2). Recommended age: 15-16."
            }
          ]
        },
        {
          "type": "html",
          "name": "advanced_entry_info",
          "visible": true,
          "html": `
<div style='background-color: #f9f9f9; border-left: 3px solid #023048; padding: 10px 15px; margin-top: 10px; font-size: 0.9em; line-height: 1.4; border-radius: 4px;'>
  <strong>Looking for a 2-Year option?</strong><br>We do not offer a standalone 2-year program, but exceptional candidates may qualify for Advanced
  Entry into the existing class. <a href='/applydp.html' target='_blank' style='color: #C1111E; text-decoration: underline; font-weight: 500;'>Check
  eligibility details here.</a>
</div>
`
        }
      ]
    },
    {
      "name": "parent_info",
      "title": "Parent / Legal Guardian Information",
      "description": "We need to contact a parent or legal representative to resolve formal issues with documents.",
      "elements": [
        {
          "type": "text",
          "name": "parent_firstname",
          "title": "Parent's or Guardian's First Name",
          "isRequired": true,
          "placeholder": "Maria"
        },
        {
          "type": "text",
          "name": "parent_lastname",
          "title": "Parent's or Guardian's Last Name",
          "isRequired": true,
          "placeholder": "Petrova"
        },
        {
          "type": "text",
          "name": "parent_email",
          "title": "Parent's or Guardian's Email",
          "description": "Please provide a valid email.",
          "isRequired": true,
          "validators": [
            {
              "type": "email"
            }
          ],
          "inputType": "email",
          "placeholder": "maria.petrova@leaders.tech"
        },
        {
          "type": "text",
          "name": "parent_preferred_language",
          "title": "Preferred Language for Oral Communication With Parent or Guardian",
          "description": "(Optional) If possible, we will try to assign a representative who speaks this language.",
          "placeholder": "e.g., English, Italian, Russian, Ukrainian"
        }
      ]
    },
    {
      "name": "school_selection",
      "title": "School Preference",
      "elements": [
        {
          "type": "html",
          "name": "school_visuals",
          "html": `
<div class='school-info-container'>
  <div class='school-logos'>
    <a href='https://isl.cy/' target='_blank' class='school-link' title='Visit The Island School website'>
      <img src='https://leaders.tech/share/island_logo.svg' alt='The Island School Logo'/>
    </a>
    <a href='https://schools.h-farm.com/en/technology-leaders-of-the-future/ ' target='_blank' class='school-link' title='Visit H-Farm International School website'>
      <img src='https://leaders.tech/share/hfarm_logo_hor.svg' alt='H-Farm International School Logo'/>
    </a>
  </div>
  <div class='school-map-image'>
    <img src='https://leaders.tech/share/school_sel.png' alt='School Locations and Campuses Map'/>
  </div>
</div>`
        },
        {
          "type": "radiogroup",
          "name": "school_choice",
          "title": "At which school would you prefer to study if admitted?",
          "description": "The applicant may select one specific school, remain open to either, or postpone the final decision until a later stage of the admissions process.",
          "isRequired": true,
          "choices": [
            {
              "value": "h_farm",
              "text": "H-Farm International School (Italy)"
            },
            {
              "value": "the_island",
              "text": "The Island School (Cyprus)"
            },
            {
              "value": "any",
              "text": "I have no preference (I am happy to study at either school)"
            },
            {
              "value": "undecided",
              "text": "I haven't decided yet"
            }
          ]
        }
      ]
    }, {
      "name": "citizenship_residence",
      "title": "Citizenship, Residence & Education",
      "elements": [
        {
          "type": "dropdown",
          "name": "citizenship",
          "title": "Country of Citizenship",
          "description": "The country that issued the student's passport. Important for visa processing.",
          "isRequired": true,
          "choices": countries,
          "autocomplete": "country-name"
        },
        {
          "type": "dropdown",
          "name": "residence_country",
          "title": "Country of Residence",
          "description": "Where the student currently lives. Important for relocation planning.",
          "isRequired": true,
          "choices": countries,
        },
        {
          "type": "text",
          "name": "residence_city",
          "title": "City of Residence",
          "isRequired": true,
          "placeholder": "Almaty"
        },
        {
          "type": "dropdown",
          "name": "timezone",
          "title": "Timezone",
          "description": "Select your local timezone so we can display exam times correctly.",
          "isRequired": true,
          "choices": []
        },
        {
          "type": "text",
          "name": "native_language",
          "title": "Native Language",
          "isRequired": true,
          "placeholder": "Armenian"
        },
        {
          "type": "text",
          "name": "native_fullname",
          "title": "Full Name in Native Language",
          "isRequired": true,
          "placeholder": "Սերգեյ Շաշկով"
        },
        {
          "type": "text",
          "name": "current_school",
          "title": "Current School Name",
          "isRequired": true,
          "placeholder": "School #123"
        },
        {
          "type": "text",
          "name": "school_system_total_years",
          "title": "Total Grades in School System",
          "description": "How many years is the full school program in your country? (e.g., 11 or 12). This helps us calculate how many years are left.",
          "isRequired": true,
          "inputType": "number",
          "min": 8,
          "max": 14,
          "placeholder": "11"
        },
        {
          "type": "text",
          "name": "current_grade",
          "title": "Current Grade",
          "description": "Enter the number of the grade the student is currently in (e.g., 9).",
          "isRequired": true,
          "inputType": "number",
          "min": 6,
          "max": 13,
          "placeholder": "9"
        },
        {
          "type": "html",
          "name": "school_transcripts_info",
          "html": `
<div style='background-color: #fff4e5; color: #333333; border-left: 4px solid #ffa117; padding: 12px 16px; margin-bottom: 15px; font-size: 0.9em; line-height: 1.4;'><strong>Academic Transcripts:</strong>
<br>For admission to H-Farm International School, we must verify your academic history for the previous year. This is a mandatory requirement for the official enrollment process and grade placement at the school.
<br>If you selected the Island School, Any, or Undecided at the previous step, uploading a transcript is optional.
<br><br>If you would like to submit your academic transcript at this stage, it may be provided in any format, including a screenshot from a laptop or mobile phone. 
If the transcript is in your native language, a translation into English is not required.
</div>`
        },
        {
          "type": "file",
          "name": "school_transcripts",
          "title": "School Transcript (Previous 2025-2026 Year)",
          "description": "Please upload grade reports or transcripts from your school.",
          "isRequired": false,
          "allowMultiple": true,
          "acceptedTypes": ".pdf, .jpg, .png, .jpeg",
          "storeDataAsText": false,
          "maxSize": 20971520
        }
      ]
    },
    {
      "name": "profile_achievements",
      "title": "Profile, English & Achievements",
      "elements": [
        {
          "type": "dropdown",
          "name": "english_level",
          "title": "Current English Level",
          "isRequired": true,
          "choices": [
            {
              "value": "A0",
              "text": "A0 (Beginner)"
            },
            {
              "value": "A1",
              "text": "A1 (Elementary)"
            },
            {
              "value": "A2",
              "text": "A2 (Pre-Intermediate)"
            },
            {
              "value": "B1",
              "text": "B1 (Intermediate)"
            },
            {
              "value": "B2",
              "text": "B2 (Upper-Intermediate)"
            },
            {
              "value": "C1",
              "text": "C1 (Advanced)"
            },
            {
              "value": "C2",
              "text": "C2 (Proficient)"
            }
          ]
        },
        {
          "type": "html",
          "name": "major_subject_info",
          // eslint-disable-next-line max-len
          "html": `
            <div
                style='background-color: #f8f9fa; padding: 16px; border-radius: 6px; border-left: 4px solid #023048; color: #333; margin-bottom: 20px; font-size: 0.95em; line-height: 1.5;'>
              <p style='margin-top: 0; margin-bottom: 10px;'>
                <strong>Important:</strong> The subject you select below will determine both your <strong>Oral Exam</strong> topic and your <strong>Academic Major</strong>
                (specialization) at the school.
              </p>
              <p style='margin-bottom: 10px;'>
                You can review the full curriculum here: <a href='https://leaders.tech/en/program.html?headless=true' target='_blank'
                                                            style='color: #0088cc; text-decoration: underline;'>Educational Program Overview</a>.
              </p>
              <p style='margin-bottom: 5px;'><strong>Exam Prerequisites & Demos:</strong></p>
              <ul style='margin-top: 0; margin-bottom: 0; padding-left: 20px;'>
                <li><a href='https://leaders.tech/en/math_oral_exam_demo.html?headless=true' target='_blank' style='color: #0088cc; text-decoration: underline;'>Mathematics
                  Exam</a></li>
                <li><a href='https://leaders.tech/en/physics_main_exam.html?headless=true' target='_blank' style='color: #0088cc; text-decoration: underline;'>Physics
                  Exam</a></li>
                <li><a href='https://leaders.tech/en/coding_exam_demo.html?headless=true' target='_blank' style='color: #0088cc; text-decoration: underline;'>Computer
                  Science Exam</a></li>
              </ul>
            </div>
          `,
        },
        {
          "type": "radiogroup",
          "name": "major_subject",
          "title": "Major Profile Subject",
          "description": "Which subject is your main focus? You will take an advanced exam in this subject.",
          "isRequired": true,
          "choices": [
            {
              "value": "math",
              "text": "Mathematics"
            },
            {
              "value": "physics",
              "text": "Physics"
            },
            {
              "value": "cs",
              "text": "Computer Science"
            },
            {
              "value": "notsure",
              "text": "I'm not sure yet"
            }
          ]
        },
        {
          "type": "html",
          "name": "missing_materials_info",
          "visibleIf": "{program_type} = '3_year' or {program_type} = '4_year'",
          "html": `<div style='background-color: #f8f9fa; padding: 16px; border-radius: 6px; border-left: 4px solid #023048; color: #333; margin-bottom: 15px; font-size: 0.95em; line-height: 1.5;'>
            <strong>Important:</strong> If you do not yet have all the required information or documents ready, please still submit your application. 
            You will be able to provide any missing materials later by emailing us at <a href='mailto:info@leaders.tech' style='color: #0088cc; text-decoration: underline;'>info@leaders.tech</a> after you receive the results of your first test.
            </div>`
        },
        {
          "type": "comment",
          "name": "olympiads_history",
          "title": "Olympiads (Last 2 Years)",
          "description": "List the Olympiads you participated in and your results. Please specify the level (Regional, National, International) and provide link to the olympiad.",
          "placeholder": "e.g., 2025 National Math Olympiad - 2nd place"
        },
        {
          "type": "comment",
          "name": "other_achievements",
          "title": "Other Achievements & Projects",
          "description": "Describe any technology/entrepreneurship projects or other achievements you are proud of."
        },
        {
          "type": "file",
          "name": "diplomas_upload",
          "title": "Attach Valuable Diplomas",
          "description": "Upload files confirming significant achievements (National/International level). Please do NOT attach certificates for minor local events.",
          "allowMultiple": true,
          "acceptedTypes": ".pdf, .jpg, .png, .jpeg",
          "storeDataAsText": false,
          "maxSize": 15242880
        },
        {
          "type": "dropdown",
          "name": "referral_source",
          "title": "How did you learn about the program?",
          "isRequired": true,
          "choices": [
            "Friends / Family",
            "Teacher / School",
            "Telegram channels",
            "Social Media (Instagram, Facebook or other)",
            "Internet Search and Ads (Google, YouTube ads)",
            "Offline events and presentations",
            "Other"
          ]
        },
        {
          "type": "text",
          "name": "referral_id",
          "title": "Referral ID",
          "description": "If you were referred to the TLF program by a specific person who provided you with a referral ID, please enter it here."
        },
        {
          "type": "radiogroup",
          "name": "who_is_filling",
          "title": "Who is filling out this application?",
          "isRequired": true,
          "choices": [
            {
              "value": "student",
              "text": "Student (Applicant)"
            },
            {
              "value": "parent",
              "text": "Parent"
            },
            {
              "value": "other",
              "text": "Other (Legal Guardian, Grandparent, Sibling, Agent, etc.)"
            }
          ]
        }
      ]
    },
    {
      "name": "privacy_consent_page",
      "title": "Data Processing Consent",
      "elements": [
        {
          "type": "html",
          "name": "privacy_notice_text",
          "html": "<h5>Privacy Notice</h5><p>By checking the box below, you consent to the processing of personal data for the admission process, including sharing data with H-Farm and The Island School. For more details, please review our <a href='https://leaders.tech/en/privacy.html' target='_blank' style='color: #0088cc; text-decoration: underline;'>Privacy Policy</a>.</p>"
        },
        {
          "type": "checkbox",
          "name": "privacy_consent",
          "titleLocation": "hidden",
          "isRequired": true,
          "choices": [
            {
              "value": "agreed",
              "text": "I confirm my consent to the processing of personal data."
            }
          ]
        }
      ]
    }
  ],
  "showProgressBar": true,
  "progressBarLocation": "top",
  "checkErrorsMode": "onValueChanged",
  "textUpdateMode": "onTyping",
  "widthMode": "responsive",
  "headerView": "advanced",
  "clearInvisibleValues": "none"
};
